import { isValidString } from '../utils/string'

const VEHICLE_GROUP_VIRTUAL_ID = 'virtual'

/**
 * Object group search filter: Decides if the given groupId
 * should be part of the filter result.
 *
 * @param {string} groupId - Selected object group id
 * @param {string[]} wfObjectGroupIds - 'groups' of the WfObject
 * @returns {boolean} Whether to include or exclude the given WfObject in the search result
 */
function filterByObjectGroup(groupId, wfObjectGroupIds) {
    if (!isValidString(groupId)) {
        return true
    }

    const groups = wfObjectGroupIds || []
    return groups.indexOf(groupId) >= 0 || (groupId === VEHICLE_GROUP_VIRTUAL_ID && !groups.length)
}

export { filterByObjectGroup }
